<template>
  <div class="base-number-input">
    <input :placeholder="label"
           :value="value"
           @input="$emit('update', { value: $event.target.valueAsNumber })"
           class="input-bordered"
           min="0"
           required
           type="number">
    <span class="focus-border"><i></i></span>
  </div>
</template>

<script>
  export default {
    name: 'BaseNumberInput',
    props: {
      value: {
        type: Number,
        default: null
      },
      label: {
        type: String,
        default: 'Label'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-number-input {
    position: relative;
  }

  h2 i {
    font-style: normal;
    background: #FFF;
    position: relative;
    padding: 10px;
    outline: none;
  }

  .input-bordered {
    border: 1px solid #CCC;
    padding: 7px 14px;
    transition: 0.4s;
    background: transparent;
    font: 14px $secondary-font;
    color: #333;
    width: 100%;
    box-sizing: border-box;
    letter-spacing: 1px;
    outline: none;
    z-index: 3;
  }

  .input-bordered ~ .focus-border:before, .input-bordered ~ .focus-border:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: $light-red;
    transition: 0.3s;
  }

  .input-bordered ~ .focus-border:after {
    top: auto;
    bottom: 0;
    left: auto;
    right: 0;
  }

  .input-bordered ~ .focus-border i:before, .input-bordered ~ .focus-border i:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 0;
    background-color: $light-red;
    transition: 0.4s;
  }

  .input-bordered ~ .focus-border i:after {
    left: auto;
    right: 0;
    top: auto;
    bottom: 0;
  }

  .input-bordered:focus ~ .focus-border:before,
  .input-bordered:focus ~ .focus-border:after,
  .has-content.input-bordered ~ .focus-border:before,
  .has-content.input-bordered ~ .focus-border:after {
    width: 100%;
    transition: 0.3s;
  }

  .input-bordered:focus ~ .focus-border i:before,
  .input-bordered:focus ~ .focus-border i:after,
  .has-content.input-bordered ~ .focus-border i:before,
  .has-content.input-bordered ~ .focus-border i:after {
    height: 100%;
    transition: 0.4s;
  }
</style>
